module.exports = __webpack_public_path__ + "img/index-promotion.69b0dbc7.png";